<template>
  <AppDialog
    :show="show"
    :title="title"
    class="paid-addon-cancelation cancellation-first-offer-dialog"
    append-to-body
    @close="toggleDialog"
  >
    <div
      v-if="loading"
      class="spinner d-flex align-items-center justify-content-center p-20"
    >
      <div class="spinner-wrapper absolute">
        <span class="hi hi-spinner hi-32 text-blue" />
      </div>
    </div>
    <div class="banner banner-md banner-blue d-flex flex-column flex-sm-row align-items-end mb-16 p-20">
      <div class="banner-content mr-20">
        <div class="title">Need more time to think?</div>
        <div class="info">
          We're offering a 30-day extension to your Insights trial so you have more time to experience all of the latest
          features, like Unusual activity alerts and updated Smart notifications.
        </div>
      </div>
      <img
        class="offer-30"
        :src="insightsAssets?.cancellation_flow?.illustration_30_days.src"
      />
    </div>
    <em class="note text-grey">* If you continue with cancellation, this offer will no longer be available.</em>
    <div class="modal-footer d-flex justify-content-end pt-30 flex-wrap p-0">
      <a
        class="btn btn-default"
        @click="next"
      >
        Continue cancellation
      </a>
      <a
        class="btn btn-primary"
        @click="applyTrialExtension"
      >
        Extend Trial
      </a>
    </div>
  </AppDialog>
</template>

<script>
import { INSIGHTS as insightsAssets } from '~/app_constants';
import { PaidAddonsResource } from '~/resources';

export default {
  name: 'CancellationFirstOfferDialog',
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    insightsAssets,
    loading: false,
  }),
  methods: {
    next(event) {
      this.$emit('next', this.id, event);
    },
    toggleDialog(event) {
      this.$emit('toggleDialog', 'firstOffer', false, event);
    },
    async applyTrialExtension() {
      const params = { organizationId: this.organizationId, addonSym: 'insights' };

      try {
        this.loading = true;
        const response = await PaidAddonsResource.extendTrial(params, { offer_type: 'extend_trial' });

        if (response && response.success) {
          window.location.reload();
        }

        if (response && response.errors) {
          throw new Error(response.errors[0] || 'Unable to complete your request.');
        }
      } catch (error) {
        this.$appMessage(error || 'Unable to complete your request. Try again later.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
